import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProofpointLoadingBar from '../components/proofpoint-loading-bar';
import { Redirect } from 'react-router-dom';
import {
    isInitialLoadSelector
} from '../selectors/ui-state-selectors';
import {
    createSession
} from '../actions/authentication-action-creators';

export class IdmVerifyContainer extends Component{
    componentDidMount(){
        this.props.createSession();
    }

    render(){
        const { isInitialLoad } = this.props;
        if( isInitialLoad ){
            return <ProofpointLoadingBar />;
        }
        return <Redirect to={'/login'} />;
    }
}

const mapDispatchToProps = {
    createSession,
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isInitialLoad: isInitialLoadSelector( state ),
    };
};

IdmVerifyContainer.propTypes = {
    createSession: PropTypes.func.isRequired,
    isInitialLoad: PropTypes.bool,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)( IdmVerifyContainer );
